import { liteClient as algoliasearch } from 'algoliasearch/lite';
import { ALGOLIA_APP_ID, ALGOLIA_APP_KEY, ALGOLIA_INDEX_NAME } from 'constants/algolia';

if (!ALGOLIA_APP_ID || !ALGOLIA_APP_KEY || !ALGOLIA_INDEX_NAME) {
  throw new Error('Algolia Application ID, API Key and Index must be defined in .env');
}

const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_APP_KEY);

export default searchClient;
